import { render, staticRenderFns } from "./Activitydetails.vue?vue&type=template&id=6184459e&scoped=true"
import script from "./Activitydetails.vue?vue&type=script&lang=js"
export * from "./Activitydetails.vue?vue&type=script&lang=js"
import style0 from "./Activitydetails.vue?vue&type=style&index=0&id=6184459e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6184459e",
  null
  
)

export default component.exports